import "@mantine/core/styles.css";
import {Links, Meta, Scripts, type MetaFunction} from "react-router";
import {MantineProvider, createTheme} from "@mantine/core";
import {defaultTheme} from "@digisthesia/remix-utils/mantine.config";
import {CsrfTokenApp} from "@digisthesia/remix-utils/csrf-token";
import {csrfTokenLoader, rootMiddlewares} from "@digisthesia/remix-utils/helpers.server";

const theme = createTheme(defaultTheme);

export function Layout({children}: {children: React.ReactNode}) {
  return (
    <html>
      <head>
        <Meta />
        <Links />
      </head>
      <body>
        <MantineProvider theme={theme}>{children}</MantineProvider>
        <Scripts />
      </body>
    </html>
  );
}

export const loader = csrfTokenLoader;
export const middleware = rootMiddlewares;
export const meta: MetaFunction = () => [{title: "Digisthesia"}];
export default CsrfTokenApp;
